import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime";import styled from '@emotion/styled'

import TagBlock from '../../../../components/Tag/TagBlock'
import TierTag from '../../../../components/Tag/TierTag'
import makeDateString from '../../../../utils/makeDateString'

const StyledTagBlock = styled(TagBlock)({
  display: 'block'
})

const OrgDetails = styled('div')({
  alignItems: 'flex-start',
  display: 'flex',
  flexShrink: 0,
  fontSize: 13,
  lineHeight: '20px'
})







const OrganizationDetails = (props) => {
  const {createdAt, tier, billingTier} = props
  return (
    _jsxs(OrgDetails, { children: [
      'Created '
      , makeDateString(createdAt)
      , tier !== 'starter' && (
        _jsx(StyledTagBlock, { children: 
          _jsx(TierTag, { tier: tier, billingTier: billingTier,} )
        })
      )
    ]})
  )
}

export default OrganizationDetails
